module.exports = __webpack_public_path__ + "files/d54040ed5db8aec295180831de77c504.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/pdf.png
// module id = 414
// module chunks = 76